export const CarLeasingRoutes = {
    ROOT: "/car-leasing",
};



// WEBPACK FOOTER //
// ./src/components/carLeasing/CarLeasingRoutes.ts